import { SearchResult } from "../../services/search";

export const isOptionSelectEvent = (reason: "reset" | "input"): boolean =>
  reason === "reset";

export const findOption = (options: SearchResult[], value: string) =>
  options.find(({ text }) => text === value);
